<template>
  <v-app>
    <v-container>
      <v-row
        class="d-flex"
      >
<!--        Request Password Reset-->
        <v-card
          v-if="!readyToReset"
          class="mx-auto px-2"
          style="width: 400px"
        >
          <v-card
            flat
            class="card-full-width section-header mt-0 pt-0"
          >
            Password Reset
          </v-card>
          <v-card
            flat
            class="mt-0"
          >
            <v-form
              ref="form"
            >
              <v-row>
                <v-col
                  cols="12"
                >
                  <v-row
                    class="mt-n4"
                  >
                    <v-col
                      cols="12"
                      class="mt-n2"
                    >
                      <v-text-field
                        ref="userEmailAddress"
                        v-model="form.email_address"
                        @keyup.enter="submitForm"
                      >
                        <template v-slot:label>
                          <div class="lbl-header">
                            Email
                          </div>
                        </template>
                      </v-text-field>
                    </v-col>
                  </v-row>
                </v-col>
                <v-col
                  cols="12"
                >
                  <v-alert
                    v-if="formErrors.length > 0"
                    class="warning"
                  >
                    <v-list
                      class="warning"
                    >
                      <v-list-item
                        v-for="(error, i) in formErrors"
                        :key="'error-' + i"
                      >
                        <v-icon
                          large
                          dark
                          class="mr-2"
                        >
                          mdi-information
                        </v-icon>
                        <span class="formError">{{ error }}</span>
                      </v-list-item>
                    </v-list>
                  </v-alert>
                </v-col>
              </v-row>
            </v-form>
          </v-card>
          <v-card
            class="d-flex mt-n7"
            flat
          >
            <v-btn
              v-if="!resetEmailSent"
              block
              tile
              color="success"
              class="mr-4"
              :loading="formOverlay"
              @click="submitForm"
            >
              Send Reset Email
            </v-btn>
            <v-alert
              v-else
              text
              type="success"
              >
                Reset Email has been sent. Please check your email inbox and spam folder(s).
            </v-alert>
          </v-card>
          <v-overlay :value="formOverlay">
            <v-progress-circular
              indeterminate
              size="64"
            ></v-progress-circular>
          </v-overlay>
        </v-card>
<!--        Commit Password Reset w/ token-->
        <v-card
          v-else-if="readyToReset && !passwordResetSuccess"
          class="mx-auto px-2"
          style="width: 400px"
        >
          <v-card
            flat
            class="card-full-width section-header mt-0 pt-0"
          >
            Confirm Password Reset
          </v-card>
          <v-card
            flat
            class="mt-0"
          >
            <v-form
              ref="form"
            >
              <v-row>
                <v-col
                  cols="12"
                >
                  <v-row
                    class="mt-n4"
                  >
                    <v-col
                      cols="12"
                      class="mt-n2"
                    >
                      <v-text-field
                        ref="userEmailAddress"
                        v-model="form.email_address"
                      >
                        <template v-slot:label>
                          <div class="lbl-header">
                            Email
                          </div>
                        </template>
                      </v-text-field>
                    </v-col>
                    <v-col
                      cols="12"
                      class="mt-n2"
                    >
                      <v-text-field
                        v-model="form.token"
                      >
                        <template v-slot:label>
                          <div class="lbl-header">
                            Token
                          </div>
                        </template>
                      </v-text-field>
                    </v-col>
                    <v-col
                      cols="12"
                      class="mt-n2"
                    >
                      <v-text-field
                        v-model="form.password"
                        :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                        :rules="[rules.required, rules.min]"
                        :type="showPassword ? 'text' : 'password'"
                        name="input-10-1"
                        label="New Password"
                        counter
                        @click:append="showPassword = !showPassword"
                        @keyup.enter="doCommitReset"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </v-col>
                <v-col
                  cols="12"
                >
                  <v-alert
                    v-if="formErrors.length > 0"
                    class="warning"
                  >
                    <v-list
                      class="warning"
                    >
                      <v-list-item
                        v-for="(error, i) in formErrors"
                        :key="'error-' + i"
                      >
                        <v-icon
                          large
                          dark
                          class="mr-2"
                        >
                          mdi-information
                        </v-icon>
                        <span class="formError">{{ error }}</span>
                      </v-list-item>
                    </v-list>
                  </v-alert>
                </v-col>
              </v-row>
            </v-form>
          </v-card>
          <v-card
            class="d-flex mt-n7"
            flat
          >
            <v-btn
              block
              tile
              color="success"
              class="mr-4"
              @click="doCommitReset"
            >
              Reset Password
            </v-btn>
          </v-card>
          <v-overlay :value="formOverlay">
            <v-progress-circular
              indeterminate
              size="64"
            ></v-progress-circular>
          </v-overlay>
        </v-card>
        <v-card
          v-else-if="passwordResetSuccess && readyToReset && isLoggedIn"
          class="mx-auto px-2"
          style="width: 400px"
        >
          <v-card
            flat
            class="card-full-width section-header mt-0 pt-0"
          >
            Password Reset Successfully!
          </v-card>
          <v-card
            flat
            class="mt-0"
          >
            <p>
              You have been logged in automatically.
            </p>
            <v-btn
              block
              tile
              to="/app/"
              color="secondary"
            >
              <v-icon
                class="mr-3"
              >
                mdi-view-dashboard
              </v-icon>
              Dashboard
            </v-btn>

          </v-card>
        </v-card>
      </v-row>
    </v-container>
  </v-app>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex'
  import {
    _COMMIT_LOG,
    AUTH_LOGIN, PUBLIC_COMMIT_PASSWORD_RESET,
    PUBLIC_REQUEST_PASSWORD_RESET,
  } from '../../store/actions.types'

  export default {
    name: 'PasswordReset',

    components: {
    },

    data: () => ({
      showPassword: false,
      isLoggingInManual: false,
      expandOnHover: false,
      formOverlay: false,
      resetEmailSent: false,
      passwordResetSuccess: false,
      form: {
        email_address: '',
        token: '',
        password: '',
        confirm_password: '',
      },
      passwordMatch: {
        error: false,
        success: false,
        messages: '',
      },
      formErrors: [],
      rules: {
        required: value => !!value || 'Required.',
        min: v => v.length >= 8 || 'Min 8 characters',
        emailMatch: () => ('The email and password you entered don\'t match'),
      },

    }),
    computed: {
      ...mapGetters(['isLoggedIn']),
      readyToReset: function () {
        return this.form.email_address && this.form.email_address.length > 0 &&
          this.form.token && this.form.token.length > 10
      },
    },
    watch: {
    },
    methods: {
      ...mapActions({
        commitLog: _COMMIT_LOG,
        login: AUTH_LOGIN,
        requestPasswordReset: PUBLIC_REQUEST_PASSWORD_RESET,
        commitPasswordReset: PUBLIC_COMMIT_PASSWORD_RESET,
      }),
      async doLogin () {
        console.log('doing login!')
        await this.login({ email_address: this.form.email_address, password: this.form.password })
        this.formOverlay = false
      },
      // CLICKS
      async submitForm () {
        this.formOverlay = true
        this.formErrors = []
        try {
          const result = await this.requestPasswordReset({ email_address: this.form.email_address })
          this.commitLog({ message: 'Password Reset Request results', result })
          this.resetEmailSent = true
        } catch (e) {
          this.commitLog({ message: 'Password Reset Request exception', error: e })
        }
        this.formOverlay = false
      },
      async doCommitReset () {
        this.formErrors = []
        this.formOverlay = true
        try {
          const result = await this.commitPasswordReset({
            email_address: this.form.email_address,
            token: this.form.token,
            password: this.form.password,
          })
          this.commitLog({ message: 'Commit Password reset results', result })
          this.passwordResetSuccess = true
          this.doLogin()
        } catch (e) {
          console.log(e)
          this.commitLog({ message: 'Error in Commit Password', error: e })
          if (e.status === 406) {

          }
        }
        this.formOverlay = false
      },
      // EVENTS
      onPasswordChange () {
        if (this.form.password === this.form.confirm_password) {
          this.passwordMatch.error = false
          this.passwordMatch.success = true
          this.passwordMatch.messages = []
        } else {
          this.passwordMatch.error = true
          this.passwordMatch.success = false
          this.passwordMatch.messages = 'Passwords must match'
        }
      },
    },
    mounted () {
      const queries = JSON.parse(JSON.stringify(this.$route.query))
      console.log('QueryString:', queries)
      if (queries.email) {
        this.form.email_address = queries.email
      }
      if (queries.token) {
        this.form.token = queries.token
      }
      if (this.form.email_address && this.form.email_address.length > 0 &&
        this.form.token && this.form.token.length > 10) {

      }
    },
  }
</script>

<style scoped>
  .v-alert .v-alert__wrapper .v-alert__content span {
    font-size: 14px;
    font-weight: 500;
    color: white;
  }
</style>
